export default "__VITE_ASSET__CRyDgsRP__"